import useTranslation from 'next-translate/useTranslation';
import { useEffect, useRef } from 'react';
import { Product, ProductVariant } from '@/models/Product';
import scrollStyles from '@/styles/HideScrollbar.module.css';
import { ProductListTypeEnum } from '@/utils/analytics/types';
import Caption, { VARIANT as CAPTION_VARIANT } from '../Caption';
import Paragraph, { VARIANT } from '../Paragraph';
import ProductVariantCard from './ProductVariantCard';
interface Props {
  productVariants: ProductVariant[];
  listType?: ProductListTypeEnum;
  position?: number;
  onContine?: VoidFunction;
  componentName?: string;
  componentId?: string | number;
  isWishlist?: boolean;
  product?: Product;
}

/**
 * A component for listing all different product variants.
 * The list currently opens in a bottom drawer.
 *
 * Design: https://www.figma.com/file/7ufg3Mz9SvODeu33zuRBtp/React-Revamp?node-id=1249%3A36142&t=fHSIDHxQqjAi81bk-1
 */
const ProductVariantList = ({
  productVariants,
  listType,
  position,
  onContine,
  componentName = '',
  componentId = '',
  isWishlist,
  product
}: Props) => {
  const {
    brand,
    name: productName
  } = productVariants[0].product as Product;
  const {
    t
  } = useTranslation('address');
  const listScrollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (listScrollRef.current) {
      listScrollRef.current.scrollTop = 0;
    }
  }, [productVariants]);
  return <div className="flex flex-col flex-1 min-h-0 max-h-full" data-sentry-component="ProductVariantList" data-sentry-source-file="ProductVariantList.tsx">
      <div ref={listScrollRef} className={`flex-1 min-h-0 overflow-y-auto overscroll-contain ${scrollStyles.scroll}`}>
        <header>
          {brand ? <Caption variant={CAPTION_VARIANT.ONE} className="font-nato-medium text-neutral-50" label={brand.name} /> : null}
          <Paragraph variant={VARIANT.BIG} isHighlighted className="text-neutral-90" data-sentry-element="Paragraph" data-sentry-source-file="ProductVariantList.tsx">
            {productName}
          </Paragraph>
        </header>
        <section className="flex flex-col gap-3 mt-4 pb-2">
          {productVariants.map(variant => <ProductVariantCard key={variant.id} productVariant={variant} listType={listType} position={position} componentName={componentName} componentId={componentId} isWishlist={isWishlist} product={product} />)}
        </section>
      </div>
      <div className="shrink-0 pt-3 bg-inherit border-t border-neutral-10">
        <button type="button" className="flex justify-center items-center bg-primary-100 py-3 rounded-lg w-full" onClick={() => onContine?.()}>
          <p className="font-medium text-white text-lg">{t('continue')}</p>
        </button>
      </div>
    </div>;
};
export default ProductVariantList;